module.exports = __webpack_public_path__ + "static/media/family.7355b60b.jpg";